import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    item: {
      display: "block",
      textAlign: "center",
      paddingBlock: 0,
      background: "#fff",

      borderRadius: 10,
      "&:hover": {
        background: "#C5E3C7",
      },
    },
    itemSm: {
      display: "flex",
      textAlign: "justify",
      width: "60%",
      borderRadius: 10,
      "&:hover": {
        background: "#C5E3C7",
      },
      boxShadow: "0px 15px 30px rgba(25, 31, 61, 0.1)",
      paddingTop: "1vh",
      paddingBottom: "1vh",
    },
    listItemIcon: {
      height: "100%",
      minWidth: "auto",
    },
    icon: {
      width: "100%",
      height: "100%",
    },
    text: {
      fontSize: "0.5",
      color: "black",
    },
    itemOpen: {
      transition: theme.transitions.create("opacity", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      opacity: 1,
    },
    itemClose: {
      transition: theme.transitions.create("opacity", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      opacity: 0,
    },
  })
);
